import { Outlet, useParams, Navigate } from 'react-router-dom';
import { useEffect } from 'react';
import { LocaleProvider, LOCALES, LOCALE_DIR, type Locale } from '../i18n';
import Starfield from './Starfield';
import Header from './Header';
import Footer from './Footer';
import LisaWidget from './lisa/LisaWidget';
import { PageContextProvider } from './lisa/PageContext';

export default function Layout() {
  const { locale } = useParams<{ locale: string }>();
  const isValidLocale = !!locale && LOCALES.includes(locale as Locale);
  const loc = (isValidLocale ? locale : 'en') as Locale;

  // Hooks must run unconditionally on every render (Rules of Hooks) — the
  // invalid-locale redirect below happens in the return value, not by
  // skipping this effect.
  useEffect(() => {
    if (!isValidLocale) return;
    document.documentElement.lang = loc;
    document.documentElement.dir = LOCALE_DIR[loc];
  }, [loc, isValidLocale]);

  if (!isValidLocale) {
    return <Navigate to="/en" replace />;
  }

  return (
    <LocaleProvider locale={loc}>
      <PageContextProvider>
        <Starfield />
        <Header />
        <main id="main">
          <Outlet />
        </main>
        <Footer />
        <LisaWidget />
      </PageContextProvider>
    </LocaleProvider>
  );
}
